/*
 * Copyright © 2018, Rezo Zero
 *
 * @file ScrollManager.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 */

import { $window, $html, $body } from '../utils/environment'
import Scroll, { Defaults, Event } from './Scroll'
import SmoothScroll from './SmoothScroll'
import $ from 'jquery'

/**
 * Basic module that detects which scrolling module we'll be using
 */
export default class {
    constructor (options) {
        this.options = options
        this.smooth = options.smooth || Defaults.smooth
        this.smoothMobile = options.smoothMobile || Defaults.smoothMobile
        this.mobileContainer = options.mobileContainer || Defaults.mobileContainer
        this.isMobile = false
    }

    init () {
        $html[0].scrollTop = 0
        $body[0].scrollTop = 0

        if (!this.smoothMobile) {
            this.isMobile = (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))
        }

        this.instance = (() => {
            if (this.smooth === true && !this.isMobile) {
                return new SmoothScroll(this.options)
            } else {
                if (this.mobileContainer) {
                    this.options.container = this.mobileContainer
                }
                return new Scroll(this.options)
            }
        })()

        this.instance.init()

        if (this.instance.scrollbar) {
            this.instance.scrollbar.addListener(e => {
                $window.triggerHandler({
                    type: 'Event.onScroll',
                    options: {
                        scrollData: e
                    }
                })
            })
        } else {
            this.instance.callbacks.onScroll = e => {
                $window.triggerHandler({
                    type: 'Event.onScroll',
                    options: {
                        scrollData: {
                            direction: {
                                x: 'none',
                                y: e.direction
                            },
                            offset: {
                                x: 0,
                                y: e.y
                            },
                            limit: e.limit
                        }
                    }
                })
            }
        }

        const $scrollToOnLoadEl = $('.js-scrollto-on-load').first()

        if ($scrollToOnLoadEl.length === 1) {
            this.options.container.triggerHandler({
                type: Event.SCROLLTO,
                options: {
                    targetElem: $scrollToOnLoadEl
                }
            })
        }
    }

    scrollTo (x, y, duration) {
        if (this.instance.scrollbar) {
            this.instance.scrollTo({
                targetOffset: y,
                speed: duration
            })
        } else {
            this.options.container.triggerHandler({
                type: Event.SCROLLTO,
                options: {
                    targetOffset: y,
                    speed: duration
                }
            })
        }
    }

    rebuild () {
        this.instance.$container.triggerHandler(Event.REBUILD)
    }

    destroy (el) {
        this.instance.destroy(el)
    }
}



// WEBPACK FOOTER //
// ./webpack/js/scroll/ScrollManager.js